import React, {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useState,
} from "react";
import { FORMS, MODULES, STATUS_GROUPS } from "../../../const";
import LoadingSpinner from "../../LoadingSpinner";
import Input from "../../input/Input";
import Dropdown from "../../input/Dropdown";
import {
  getBulkDropdownData,
  getDropdownData,
  getOtherRefSearchDropdown,
} from "../../../api/keyvalue";
import { statusByContext } from "../../../api/statusApi";
import {
  findStkGroupById,
  findUserGroupById,
  masterShiftSearch,
} from "../../../api/shiftAssignmentApi";
import SearchDropdown from "../../input/SearchDropdown";
import { emptyValidator } from "../../../validators";
import { stakeholderValidation } from "../../validations/stakeholderCreation";
import InfoList from "../../InfoList";
import { formatFromJsonDate } from "../../../dateConfig";
import { User } from "react-feather";
import useUserCompany from "../../../hooks/useUserCompany";

const FORM = FORMS.CALL_CENTER_SHIFT_ASSIGNMENT.SHIFT_ASSIGN.form;
const ShiftAssignmentForm = forwardRef(
  (
    {
      errors,
      dropdown,
      isLoading,
      currentValues,
      currentActionValues,
      editMode,
      setUserGroupLoad,
      setStkGroupLoad,
    },
    ref,
  ) => {
    const [currentErrors, setCurrentErrors] = useState(
      errors.shiftAssignmentErrors,
    );

    const userCompany = useUserCompany();

    const [company, setCompany] = useState(
      userCompany ? userCompany.comId : null,
    );

    useEffect(() => {
      setCompany(userCompany ? userCompany.comId : null);
    }, [userCompany]);

    const [currentActionErrors, setCurrentActionErrors] = useState(
      errors.shiftAssignmentActionErrors,
    );
    const today = new Date().toISOString().split("T")[0];
    // bool
    const [isAddLoading, setIsAddLoading] = useState(false);
    const [buttonClicked, setButtonClicked] = useState(false);
    const [searchFieldReset, setSearchFieldReset] = useState(false);

    //dropdown
    const [activeOptions, setActiveOptions] = useState([]);
    const [statusOptions, setStatusOptions] = useState([]);
    const [masterShiftsOptions, setMasterShiftsOptions] = useState([]);
    const [stakeholderGroupOptions, setStakeholderGroupOptions] = useState([]);
    const [userGroupOptions, setUserGroupOptions] = useState([]);
    const [actionStatusOptions, setActionStatusOptions] = useState([]);
    const [initialActive, setInitialActive] = useState(
      editMode ? currentValues?.sfhActive : 1,
    );

    const [shiftAssignmentData, SetShiftAssignmentData] = useState(
      editMode
        ? {
            ...currentValues,
            sfhCompany: company,
            sfhDateStart: currentValues.sfhDateStart?.includes("T")
              ? currentValues.sfhDateStart.split("T")[0]
              : currentValues.sfhDateStart,
            sfhDateEnd: currentValues.sfhDateEnd?.includes("T")
              ? currentValues.sfhDateEnd.split("T")[0]
              : currentValues.sfhDateEnd,
            minToDate: currentValues.sfhDateStart?.includes("T")
              ? currentValues.sfhDateStart.split("T")[0]
              : currentValues.sfhDateStart,
          }
        : {
            sfhCode: "",
            sfhReferance: "",
            sfhCompany: company,
            sfhShift: null,
            sfhDateStart: "",
            sfhDateEnd: "",
            sfhDescription: "",
            sfhStatus: 2,
            sfhActive: 1,
            stakeholderGroup: null,
            userGroup: null,
            minToDate: today,
          },
    );

    const [shiftActionsData, setShiftActionsData] = useState({
      sdsId: null,
      sdsCode: "",
      sdsReferance: "",
      sdsCompany: company,
      sdsShiftHeader: null,
      sdsActions: null,
      sdsActionStatus: [],
      sdsDate: null,
      sdsDescription: "",
      sdsStatus: 2,
      sdsActive: 1,
    });

    useEffect(() => {
      (async () => {
        if (editMode && currentActionValues) {
          let currentActions = [];
          let id = 2;
          for (let currentActionValue of currentActionValues) {
            currentActions.push(
              // ...currentActionValue,
              currentActionValue.sdsActionStatus,
            );
            ++id;
          }
          setShiftActionsData({
            sdsActionStatus: currentActions,
          });
        }
      })();
    }, [editMode, currentActionValues]);

    useEffect(() => {
      setCurrentErrors(errors.shiftAssignmentErrors);
      setCurrentActionErrors(errors.shiftAssignmentActionErrors);
    }, [errors]);

    useEffect(() => {
      (async () => {
        //new
        const { active: activeData, status: statusData } =
          await getBulkDropdownData([{ key: "active" }, { key: "status" }]);

        setActiveOptions(activeData);
        setStatusOptions(statusData);

        const userData = await getOtherRefSearchDropdown({
          type: "shift_groups",
          param1: "",
          param2: "2",
        });
        const updatedUserData = userData.map((userData) => {
          return {
            ...userData,
            text: userData.title,
          };
        });
        setUserGroupOptions(updatedUserData);
        const stakeholderData = await getOtherRefSearchDropdown({
          type: "shift_groups",
          param1: "",
          param2: "1",
        });
        const updatedStkData = stakeholderData.map((stakeholderData) => {
          return {
            ...stakeholderData,
            text: stakeholderData.title,
          };
        });
        setStakeholderGroupOptions(updatedStkData);

        // const actionStatusData = await statusByContext(STATUS_GROUPS.ALL);
        // setActionStatusOptions(actionStatusData);

        const actionStatusData = await getOtherRefSearchDropdown({
          type: "shift_action",
          param1: "",
        });
        const updatedActionStatusData = actionStatusData.map(
          (actionStatusData) => {
            return {
              ...actionStatusData,
              text: actionStatusData.title,
            };
          },
        );
        setActionStatusOptions(updatedActionStatusData);
      })();
    }, []);

    useImperativeHandle(ref, () => ({
      getAssignmentData: () => ({
        ...shiftAssignmentData,
      }),
      getActionsData: () => ({
        ...shiftActionsData,
      }),
      isDeletedActive: () =>
        shiftAssignmentData.sfhActive === 2 && initialActive !== 2,
      resetForm: () => {
        SetShiftAssignmentData({
          sfhCode: "",
          sfhReferance: "",
          sfhCompany: company,
          sfhShift: null,
          sfhDateStart: "",
          sfhDateEnd: "",
          sfhDescription: "",
          sfhStatus: 2,
          sfhActive: 1,
          stakeholderGroup: "",
          userGroup: "",
        });
        setShiftActionsData({
          sdsId: null,
          sdsCode: "",
          sdsReferance: "",
          sdsCompany: company,
          sdsShiftHeader: null,
          sdsActions: null,
          sdsActionStatus: [],
          sdsDate: null,
          sdsDescription: "",
          sdsStatus: 2,
          sdsActive: 1,
        });
        setSearchFieldReset(true);
      },
    }));

    const adduserGroup = async (data) => {
      const response = await findUserGroupById(data);

      setUserGroupLoad(response);
    };
    const addStkGroup = async (data) => {
      const response = await findStkGroupById(data);
      setStkGroupLoad(response);
    };

    return (
      <>
        {isLoading ? (
          <LoadingSpinner />
        ) : (
          <form
            className="ui form"
            style={{ overflowY: "auto", height: "75vh" }}
          >
            <div className="ui segment">
              <h4 className="ui dividing header">Shift Assignment</h4>
              <div className="two fields">
                <Input
                  label="Shift Assignment code"
                  error={currentErrors.sfhCode}
                  module={MODULES.Transaction}
                  form={FORM}
                  field="sfh_code"
                  editMode={editMode}
                  resetError={() =>
                    setCurrentErrors((prevState) => {
                      const { sfhCode: _, ...rest } = prevState;
                      return rest;
                    })
                  }
                  name="shiftCode"
                  value={shiftAssignmentData.sfhCode}
                  onChange={(e) => {
                    SetShiftAssignmentData((prevState) => ({
                      ...prevState,
                      sfhCode: e.target.value,
                    }));
                  }}
                  disabled={true}
                />
              </div>
              <div className="two fields">
                <SearchDropdown
                  key={1}
                  required={true}
                  editMode={editMode}
                  module={MODULES.Transaction}
                  form={FORM}
                  field="sfh_shift"
                  reset={searchFieldReset}
                  setReset={setSearchFieldReset}
                  onResultSelect={(data) =>
                    SetShiftAssignmentData((prevState) => ({
                      ...prevState,
                      sfhShift: data,
                    }))
                  }
                  clearable={true}
                  onClear={() => {
                    SetShiftAssignmentData((prevState) => ({
                      ...prevState,
                      sfhShift: "",
                    }));
                  }}
                  fieldInfo={{
                    tableName: "masterdata.tms_m_shifts",
                    primaryKey: "shi_id",
                    fieldName: "shi_shift",
                    id: shiftAssignmentData.sfhShift,
                  }}
                  api={masterShiftSearch}
                  label="Master Shift"
                  error={currentErrors.sfhShift}
                  resetError={() =>
                    setCurrentErrors((prevState) => {
                      const { sfhShift: _, ...rest } = prevState;
                      return rest;
                    })
                  }
                />
              </div>
              <div className="two fields">
                <Input
                  required={true}
                  label="Start Date"
                  error={currentErrors.sfhDateStart}
                  module={MODULES.Transaction}
                  form={FORM}
                  field="sfh_start"
                  editMode={editMode}
                  resetError={() =>
                    setCurrentErrors((prevState) => {
                      const { sfhDateStart: _, ...rest } = prevState;
                      return rest;
                    })
                  }
                  type="date"
                  name="startDate"
                  placeholder="From"
                  value={shiftAssignmentData.sfhDateStart}
                  onChange={(e) => {
                    SetShiftAssignmentData((prev) => ({
                      ...prev,
                      sfhDateStart: e.target.value,
                      sfhDateEnd: "",
                      minToDate: e.target.value,
                    }));
                  }}
                  min={
                    new Date().toISOString().split("T")[0] <
                    shiftAssignmentData.minToDate
                      ? new Date().toISOString().split("T")[0]
                      : shiftAssignmentData.minToDate
                  }
                />
                <Input
                  required={true}
                  label="End Date"
                  error={currentErrors.sfhDateEnd}
                  module={MODULES.Transaction}
                  form={FORM}
                  field="sfh_end"
                  editMode={editMode}
                  resetError={() =>
                    setCurrentErrors((prevState) => {
                      const { sfhDateEnd: _, ...rest } = prevState;
                      return rest;
                    })
                  }
                  type="date"
                  name="endDate"
                  placeholder="End Date"
                  value={shiftAssignmentData.sfhDateEnd}
                  // min={blackListData.minToDate} // Set the minimum date for the "To" date input
                  onChange={(e) => {
                    SetShiftAssignmentData((prev) => ({
                      ...prev,
                      sfhDateEnd: e.target.value,
                    }));
                  }}
                  min={shiftAssignmentData.minToDate}
                />
              </div>
              <div className="two fields">
                <Dropdown
                  disabled={editMode}
                  clearable
                  search={true}
                  options={stakeholderGroupOptions}
                  placeholder="Stakeholder Group"
                  label="Stakeholder Group"
                  error={currentErrors.stakeholderGroup}
                  module={MODULES.Transaction}
                  form={FORM}
                  field="stakeholder_group"
                  editMode={editMode}
                  value={shiftAssignmentData.stakeholderGroup}
                  onChange={(e, data) => {
                    SetShiftAssignmentData((prevState) => ({
                      ...prevState,
                      stakeholderGroup: data.value,
                    }));

                    if (data.value) addStkGroup(data.value);
                    else setStkGroupLoad([]);
                    // SetShiftAssignment(data.value);
                  }}
                  resetError={() =>
                    setCurrentErrors((prevState) => {
                      const { stakeholderGroup: _, ...rest } = prevState;
                      return rest;
                    })
                  }
                  // multiple={true}
                />
                <Dropdown
                  disabled={editMode}
                  clearable
                  search={true}
                  options={userGroupOptions}
                  placeholder="User Group"
                  label="User Group"
                  error={currentErrors.userGroup}
                  module={MODULES.Transaction}
                  form={FORM}
                  field="sha_status"
                  editMode={editMode}
                  value={shiftAssignmentData.userGroup}
                  onChange={(e, data) => {
                    SetShiftAssignmentData((prevState) => ({
                      ...prevState,
                      shaMasterStatus: data.value,
                    }));
                    if (data.value) adduserGroup(data.value);
                    else setUserGroupLoad([]);
                  }}
                  resetError={() =>
                    setCurrentErrors((prevState) => {
                      const { shaMasterStatus: _, ...rest } = prevState;
                      return rest;
                    })
                  }
                  // multiple={true}
                />
              </div>
              <div className="field">
                <Dropdown
                  required={true}
                  clearable
                  search={true}
                  options={actionStatusOptions}
                  placeholder="Actions"
                  label="Actions"
                  error={currentActionErrors.sdsActionStatus}
                  module={MODULES.Transaction}
                  form={FORM}
                  field="sha_status"
                  editMode={editMode}
                  value={shiftActionsData.sdsActionStatus}
                  onChange={(e, data) => {
                    setShiftActionsData((prevState) => ({
                      ...prevState,
                      sdsActionStatus: data.value,
                    }));
                    // addStatusCode(data.value);
                  }}
                  resetError={() =>
                    setCurrentActionErrors((prevState) => {
                      const { sdsActionStatus: _, ...rest } = prevState;
                      return rest;
                    })
                  }
                  multiple={true}
                />
              </div>
              <div className="two fields">
                <Input
                  label="Description"
                  error={currentErrors.sfhDescription}
                  module={MODULES.Transaction}
                  form={FORM}
                  field="blk_description"
                  editMode={editMode}
                  resetError={() =>
                    setCurrentErrors((prevState) => {
                      const { sfhDescription: _, ...rest } = prevState;
                      return rest;
                    })
                  }
                  placeholder="Description"
                  style={{
                    display: "flex",
                    flexDirection: "column",
                  }}
                  value={shiftAssignmentData.sfhDescription}
                  onChange={(e) => {
                    SetShiftAssignmentData((prevState) => ({
                      ...prevState,
                      sfhDescription: e.target.value,
                    }));
                  }}
                />
              </div>
              <div className="two fields">
                <Dropdown
                  required={true}
                  label="Status"
                  error={currentErrors.sfhStatus}
                  module={MODULES.Transaction}
                  form={FORM}
                  field="blk_status"
                  editMode={editMode}
                  resetError={() =>
                    setCurrentErrors((prevState) => {
                      const { sfhStatus: _, ...rest } = prevState;
                      return rest;
                    })
                  }
                  placeholder="Status"
                  options={statusOptions}
                  value={shiftAssignmentData.sfhStatus}
                  style={{ height: "20px" }}
                  onChange={(e, data) => {
                    SetShiftAssignmentData((prevState) => ({
                      ...prevState,
                      sfhStatus: data.value,
                    }));
                  }}
                />
                <Dropdown
                  required={true}
                  label="Active"
                  error={currentErrors.sfhActive}
                  module={MODULES.Transaction}
                  form={FORM}
                  field="blk_active"
                  // authenticated={true}
                  needDeletePermission={true}
                  editMode={editMode}
                  resetError={() =>
                    setCurrentErrors((prevState) => {
                      const { sfhActive: _, ...rest } = prevState;
                      return rest;
                    })
                  }
                  placeholder="Active"
                  options={activeOptions}
                  value={shiftAssignmentData.sfhActive}
                  style={{ height: "20px" }}
                  onChange={(e, data) => {
                    SetShiftAssignmentData((prevState) => ({
                      ...prevState,
                      sfhActive: data.value,
                    }));
                  }}
                />
              </div>
            </div>
            {editMode && (
              <InfoList
                title="User Information"
                content={[
                  {
                    title: "Created By",
                    value: shiftAssignmentData.createdBy
                      ? shiftAssignmentData.createdBy
                      : "N/A",
                  },
                  {
                    title: "Created Date",
                    value: shiftAssignmentData.createdDate
                      ? formatFromJsonDate(shiftAssignmentData.createdDate)
                      : "N/A",
                  },
                  {
                    title: "Last Modified By",
                    value: shiftAssignmentData.lastModifiedBy
                      ? shiftAssignmentData.lastModifiedBy
                      : "N/A",
                  },
                  {
                    title: "Last Modified Date",
                    value: shiftAssignmentData.lastModifiedDate
                      ? formatFromJsonDate(shiftAssignmentData.lastModifiedDate)
                      : "N/A",
                  },
                ]}
                Icon={User}
              />
            )}
          </form>
        )}
      </>
    );
  },
);
export default ShiftAssignmentForm;
